// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Waiting icon for different situtations
 */
.fpd-waiting {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  margin-left: 10px;
  margin-right: 10px;
  border: 3px solid rgba(20,20,20,.4);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}

/**
 * Overwrite empty handling of modern themes.
 */
.fpd-modal-content div:empty ,.fpd-container fpd-actions-bar div:empty, .fpd-container picture:empty, .fpd-show-empty div:empty, .fpd-show-empty picture:empty {
  display: block;
}

.fpd-container a:empty, .fpd-container i:empty, .fpd-container span:empty, .fpd-container svg:empty, .fpd-modal-wrapper span:empty, .fpd-container span:empty, .sp-container span:empty {
  display: inline;
}

.fpd-container button:empty, .fpd-container canvas:empty, .fpd-container figure:empty {
  display: inline-block;
}
.fpd-container canvas {
  letter-spacing: normal;
}

/* .fpd-element-toolbar-smart .sp-container div.sp-fill:empty {
    display: none;
} */

/**
 * View Selection
 */
 .fpd-container.fpd-views-outside-below fpd-views-nav {
    display: none
 }

.fpd-view-selection-wrapper .fpd-item.fpd-active {
    border: 1px solid var(--fpd-primary-color);
}

/**
 * For total extra
 */
.fpd-totel-extra {
  padding: 5px 12px;
  background: #fff;
  text-align: center;
}

.fpd-totel-extra span {
  color: #AD0000;
  display: inline-block;
  font-weight: bold;
  margin: 0px 5px;
}

/**
 * Customize Button
 */
#fpd-customize-button {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

/**
 * 3D Preview Setup
 */
 #fpd-3d-preview-placeholder {
  height: 500px;
 }

.fpd-modal-product-designer .fpd-container fpd-actions-bar .fpd-done span.fpd-total-price {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/fpd-fe-shopify.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,KAAK,iCAAiC,EAAE;AAC1C;AACA;EACE,KAAK,iCAAiC,EAAE;AAC1C;;AAEA;;EAEE;AACF;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;;EAEE;CACD;IACG;CACH;;AAED;IACI,0CAA0C;AAC9C;;AAEA;;EAEE;AACF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE;AACF;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE;CACD;EACC,aAAa;CACd;;AAED;EACE,aAAa;AACf","sourcesContent":["/**\n * Waiting icon for different situtations\n */\n.fpd-waiting {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  margin-left: 10px;\n  margin-right: 10px;\n  border: 3px solid rgba(20,20,20,.4);\n  border-radius: 50%;\n  border-top-color: #fff;\n  animation: spin 1s ease-in-out infinite;\n  -webkit-animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to { -webkit-transform: rotate(360deg); }\n}\n@-webkit-keyframes spin {\n  to { -webkit-transform: rotate(360deg); }\n}\n\n/**\n * Overwrite empty handling of modern themes.\n */\n.fpd-modal-content div:empty ,.fpd-container fpd-actions-bar div:empty, .fpd-container picture:empty, .fpd-show-empty div:empty, .fpd-show-empty picture:empty {\n  display: block;\n}\n\n.fpd-container a:empty, .fpd-container i:empty, .fpd-container span:empty, .fpd-container svg:empty, .fpd-modal-wrapper span:empty, .fpd-container span:empty, .sp-container span:empty {\n  display: inline;\n}\n\n.fpd-container button:empty, .fpd-container canvas:empty, .fpd-container figure:empty {\n  display: inline-block;\n}\n.fpd-container canvas {\n  letter-spacing: normal;\n}\n\n/* .fpd-element-toolbar-smart .sp-container div.sp-fill:empty {\n    display: none;\n} */\n\n/**\n * View Selection\n */\n .fpd-container.fpd-views-outside-below fpd-views-nav {\n    display: none\n }\n\n.fpd-view-selection-wrapper .fpd-item.fpd-active {\n    border: 1px solid var(--fpd-primary-color);\n}\n\n/**\n * For total extra\n */\n.fpd-totel-extra {\n  padding: 5px 12px;\n  background: #fff;\n  text-align: center;\n}\n\n.fpd-totel-extra span {\n  color: #AD0000;\n  display: inline-block;\n  font-weight: bold;\n  margin: 0px 5px;\n}\n\n/**\n * Customize Button\n */\n#fpd-customize-button {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n/**\n * 3D Preview Setup\n */\n #fpd-3d-preview-placeholder {\n  height: 500px;\n }\n\n.fpd-modal-product-designer .fpd-container fpd-actions-bar .fpd-done span.fpd-total-price {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
